import React, { useEffect } from 'react';
import { useLanguage } from '../../context/LanguageContext';

const PARTICLE_COLORS = ['#3b82f6', '#8b5cf6', '#10b981', '#f59e0b', '#ef4444', '#06b6d4'];

const HelpCompletionCelebration = ({ onComplete }) => {
    const { language } = useLanguage();

    useEffect(() => {
        const timer = setTimeout(onComplete, 2500);
        return () => clearTimeout(timer);
    }, [onComplete]);

    return (
        <div className="fixed inset-0 z-[320] pointer-events-none flex items-center justify-center">
            {/* Central success message */}
            <div className="bg-white/95 dark:bg-gray-900/95 backdrop-blur-xl rounded-2xl px-8 py-6 shadow-2xl border border-white/20 dark:border-white/10 pointer-events-auto animate-help-celebration-in">
                <div className="text-center">
                    <div className="w-12 h-12 bg-green-100 dark:bg-green-500/10 rounded-full flex items-center justify-center mx-auto mb-3">
                        <svg className="w-6 h-6 text-green-600 dark:text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                        </svg>
                    </div>
                    <p className="text-sm font-black text-gray-900 dark:text-white">
                        {language === 'fr' ? 'Visite terminée !' : 'Tour complete!'}
                    </p>
                    <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                        {language === 'fr'
                            ? 'Clique sur « ? Guide » pour la relancer.'
                            : 'Click "? Guide" to restart it.'}
                    </p>
                </div>
            </div>

            {/* Sparkle particles */}
            {Array.from({ length: 12 }).map((_, i) => (
                <div
                    key={i}
                    className="absolute w-2 h-2 rounded-full animate-help-particle"
                    style={{
                        backgroundColor: PARTICLE_COLORS[i % PARTICLE_COLORS.length],
                        animationDelay: `${i * 60}ms`,
                        left: '50%',
                        top: '50%',
                        '--particle-angle': `${i * 30}deg`,
                        '--particle-distance': `${60 + (i % 3) * 30}px`,
                    }}
                />
            ))}
        </div>
    );
};

export default HelpCompletionCelebration;
